import { useEffect, useState } from "react";
import { Affix, Button, Text } from "antd";
import { useSelector, useDispatch } from "react-redux";
import styles from "./styles.module.css";
import { setUserInfo, setIsActAsUser } from "../../../redux/action/app";
import { useNavigate } from "react-router-dom";
import { destroyActAsUser, getProfile } from "../../../util/API";

const Footer = ({ lng = "vi" }) => {
  const userInfo = useSelector((state) => state.app.userInfo);
  const isActAsUser = useSelector((state) => state.app.isActAsUser);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  if (!isActAsUser) {
    return <></>
  }

  const getUserInfo = async () => {
    try {
      const response = await getProfile();
      dispatch(setUserInfo(response.data));
    } catch (error) {
      console.error(error);
      // TODO: Handle error while fetching profile
    }
  };

  const hanldeDestroyActAsUser = async () => {
    
    const response = await destroyActAsUser();
    if (response.status === 200) {
      const { user, jwt } = response.data;
      localStorage.setItem("token", jwt);
      localStorage.setItem("user", JSON.stringify(user));
      dispatch(setIsActAsUser(false));
      await getUserInfo();
      if (lng === "en") navigate(`/nomination/profile`);
      else navigate(`/nomination/ho-so`);
    }
  }

  return (
    <div className={styles.root}>
      <p className={styles.actasuser}>{userInfo?.nominatee?.name} </p>
      
      <Button onClick={hanldeDestroyActAsUser}>
        Ngừng hoạt động như là người dùng
      </Button>
     </div>
    
  );
};

export default Footer;
